/**
 * Card DISPLAY helpers.
 *
 * The formatters and validators that used to live here — `formatCardNumber`, `formatCardExpiry`,
 * `formatCardCvc`, `validateCardExpiry` — were removed with the onboarding payment stub, their only
 * consumer. They existed to accept a raw card number into our own inputs, and nothing in this app
 * does that any more: every card surface hands the fields to Stripe's Payment Element, so the
 * number goes browser → Stripe and never through our DOM or React state.
 *
 * Deliberately not kept "in case". A ready-made set of PAN formatters is how the next raw card form
 * gets written.
 */

import type { PaymentMethod } from "@/interfaces/paymentMethod";

const CARD_BRAND_LABELS: Record<string, string> = {
  visa: "VISA",
  mastercard: "MC",
  amex: "AMEX",
  american_express: "AMEX",
  discover: "DISC",
  diners: "DINERS",
  diners_club: "DINERS",
  jcb: "JCB",
  unionpay: "UNION",
  eftpos_au: "EFTPOS",
  cartes_bancaires: "CB",
  link: "LINK",
};

export function cardBrandLabel(brand: string | null | undefined): string {
  if (!brand) return "CARD";
  return CARD_BRAND_LABELS[brand.toLowerCase().replace(/[\s-]+/g, "_")] ?? "CARD";
}

/** The card that funds a credit purchase: the default one, else the first; null with no cards. */
export function defaultFundingCard(cards: readonly PaymentMethod[]): PaymentMethod | null {
  return cards.find((c) => c.isDefault) ?? cards[0] ?? null;
}
